import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { REMOVE_REPORT } from "../report.queries";
import {
  RemoveReportMutation,
  RemoveReportMutationVariables,
} from "../../../__generated__/RemoveReportMutation";

export const useRemoveReport = () => {
  return useMutation<RemoveReportMutation, RemoveReportMutationVariables>(REMOVE_REPORT, {
    refetchQueries: ["ReportsQuery"],
    update(cache) {
      evictFields(cache, ["report", "reports"]);
    },
  });
};
